module.exports = __webpack_public_path__ + "static/media/sosa-poster.b86ccdd7.jpg";